import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import files from '@/store/shared/files'

export default {
  namespaced: true,
  state () {
    return {
      invoice: null
    }
  },
  actions,
  mutations,
  getters,
  modules: {
    files
  }
}
